import { Box, Container, Typography } from "@mui/material";
import React from "react";
import { our_story } from "../../assets/images";

const OurStorySection = () => {
  return (
    <Box
      sx={{
        width: "100vw",
      }}
    >
      <Container
        sx={{
          display: "flex",
          flexDirection: { xs: "column-reverse", md: "row" },
          justifyContent: "space-between",
          mt: 5,
          backgroundImage: `url(${our_story})`,
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
          height: { md: "90vh" },
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            width: { xs: "100%", md: "45%" },
            justifyContent: "flex-end",
          }}
          component="section"
          id="our-story"
        >
          <Typography variant="h7" sx={{ mb: "1rem" }}>
            Our Beginning
          </Typography>
          <Typography
            variant="h2"
            sx={{ width: { xs: "100%", md: "95%" }, mb: "1rem" }}
          >
            The birth of{" "}
            <span style={{ color: "#DB5430", textTransform: "uppercase" }}>
              Eagle Learning
            </span>
            {""} in Zimbabwe
          </Typography>
          <Typography variant="body1">
            This story and these questions were what went through Peter
            Cunningham, the co-founder of EAGLE Learning. Moved to address the
            issue of hopelessness in the next generation, Peter and his sister
            Renee Cunningham, established EAGLE Learning in 2017, launching it
            with a pilot project of placing tablets and computers in different
            communities to see how children engaged and learned with minimal
            input. Their findings were staggering, as children engaged with the
            tools and grew in ways that we so encouraging and exciting to see.
            The model has since developed and grown itself, in a way that we see
            the eyes of children light up with joy and hope.
          </Typography>
        </Box>

        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            width: { xs: "100%", md: "45%" },
            mb: { xs: 10 },
          }}
        >
          <Typography variant="h7" sx={{ mb: "1rem" }}>
            The Spark
          </Typography>
          <Typography
            variant="h2"
            sx={{ width: { xs: "100%", md: "100%" }, mb: "1rem" }}
          >
            The{" "}
            <span style={{ color: "#DB5430", textTransform: "uppercase" }}>
              Questions
            </span>{" "}
            that changed{" "}
            <span style={{ color: "#DB5430", textTransform: "uppercase" }}>
              Everything
            </span>
          </Typography>
          <Typography variant="body1">
            Imagine driving down a dusty road in rural Africa with huts dotted
            in between thick bush, the sun beating down relentlessly. Imagine
            catching sight of 2 young girls on the side of the road selling
            mangos, earnestly looking towards your car because you are their
            only hope of getting anything for their efforts today. Why are they
            not at school? Where are their parents? What will happen to them
            next? Why are they so young yet their eyes tell so many stories of
            what they have gone through?
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default OurStorySection;
